import {Button as Btn} from "react-bootstrap";

const Button = (props: any) => {
    // @ts-ignore
    return <Btn {...props} />; // Bypass type checking here
  };

export default Button;